export default __webpack_public_path__ + "static/section_5_details_2-9b9dd73d5545468ceac5f5632736e4a8.png";